import { FC, MutableRefObject, Children, cloneElement, } from 'react';
import { ProForm } from '../antd';
import { SimpleFormItemEnum } from './interface';
import { filterSpaceType } from '../SearchForm/interface/baseInterface';
import { FormInstance } from 'antd/lib/form';
import './style.less';

export interface SimpleFormProps {
  /** 表单对象 */
  actionRef?: MutableRefObject<FormInstance | undefined>;
  /** 是否过滤空值 */
  filterEmpty?: boolean;
  /** 空格过滤规格 */
  filterSpace?: filterSpaceType;
  children?: any;
}
/** 简单form表单 */
const SimpleForm: FC<SimpleFormProps> = props => {
  const { children, actionRef } = props;
  const [form] = ProForm.useForm();
  if (actionRef) actionRef.current = form;
  const renderChildren = () => {
    return Children.map(children, child => {
      const childElement = child as React.FunctionComponentElement<
        SimpleFormProps
      >;
      if (!childElement.type) return null;
      const { displayName } = childElement.type;
      if (displayName && displayName in SimpleFormItemEnum) {
        const otherParams: any = { form: form };
        return cloneElement(childElement, otherParams);
      } else {
        console.error('Warning: SimpleForm has a child which is not a Item');
      }
    });
  };
  return (
    <ProForm form={form} component={false}>
      {renderChildren()}
    </ProForm>
  );
};

export default SimpleForm;
